<script setup lang="ts">
  import LockIcon from '@/shared/assets/icons/LockIcon.svg';
  import PdfFileIcon from '@/shared/assets/icons/PdfFileIcon.svg';
  import SaveIcon from '@/shared/assets/icons/SaveIcon.svg';
  import UserIcon from '@/shared/assets/icons/UserIcon.svg';
  import { ColoredButton } from '@/shared/ui';

  withDefaults(
    defineProps<{
      filling?: boolean;
      viewing?: boolean;
      canSave?: boolean;
      showExportPdf?: boolean;
    }>(),
    {
      filling: false,
      viewing: false,
      canSave: true,
      showExportPdf: true,
    }
  );

  const emit = defineEmits<{
    (e: 'cancel'): void;
    (e: 'save'): void;
  }>();
</script>

<template>
  <div
    class="flex items-center justify-between gap-4"
    data-testid="generate-record-action-bar"
  >
    <div class="flex items-center gap-3">
      <template v-if="filling">
        <ColoredButton
          data-testid="collaborators-button"
          text="Colaboradores"
          :icon="UserIcon"
          icon-alt="Colaboradores"
          disabled
        />
        <ColoredButton
          data-testid="archive-button"
          text="Arquivar"
          :icon="LockIcon"
          icon-alt="Arquivar"
          disabled
        />
      </template>
      <ColoredButton
        v-if="showExportPdf"
        data-testid="export-pdf-button"
        text="Exportar PDF"
        :icon="PdfFileIcon"
        icon-alt="Exportar PDF"
        disabled
      />
    </div>
    <div class="flex items-center gap-3">
      <ColoredButton
        data-testid="cancel-button"
        outlined
        color="gray-03"
        :text="viewing ? 'Voltar' : 'Cancelar'"
        @click="emit('cancel')"
      />
      <ColoredButton
        v-if="!viewing"
        data-testid="save-button"
        text="Salvar"
        :icon="SaveIcon"
        icon-alt="Salvar"
        :disabled="!canSave"
        @click="emit('save')"
      />
    </div>
  </div>
</template>
